// frontend/src/context/NotificationAlertContext.js
import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const NotificationAlertContext = createContext({
  alertMsg: null,
  triggerAlert: () => {},
});

export const NotificationAlertProvider = ({ children }) => {
  const [alertMsg, setAlertMsg] = useState(null);
  const timerRef = useRef(null);

  const triggerAlert = useCallback((message) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setAlertMsg(message);
    timerRef.current = setTimeout(() => setAlertMsg(null), 3000);
  }, []);

  return (
    <NotificationAlertContext.Provider value={{ alertMsg, triggerAlert }}>
      {children}
    </NotificationAlertContext.Provider>
  );
};

export const useNotificationAlert = () => useContext(NotificationAlertContext);
